import { useRef, useEffect } from 'react';

/**
 * Exécute `effect` une seule fois, même si le composant se démonte puis se remonte rapidement.
 * ✅ IMPORTANT: Ne pas mettre effect dans les dépendances pour éviter les boucles infinies
 */
export function useOnceEffect(effect: () => void) {
  const hasRun = useRef(false);

  useEffect(() => {
    if (!hasRun.current) {
      hasRun.current = true;
      effect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // ✅ Tableau vide volontairement - on veut exécuter une seule fois
}
